import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { customAlphabet } from "nanoid";
import { toast } from "react-toastify";
import { v4 } from "uuid";
import { storage } from "../firebase/firebase";

export function generateOTP() {
  const alphabet = "0123456789";
  const nanoid = customAlphabet(alphabet, 5);
  return nanoid();
}

export const uploadMultiple = async (uploadImage, mediaURLs, setMediaURLs, setLoading, done, action) => {
  const promises = [];
  if (!done) {
    Array.from(uploadImage).forEach((image) => {
      const imageRef = ref(storage, `contents/${v4()}${image.name}`);
      const uploadTask = uploadBytesResumable(imageRef, image);
      promises.push(uploadTask);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          setLoading(true);
        },
        (error) => {
          console.log(error.message);
          setLoading(false);
        },
        async () => {
          await getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            setMediaURLs((prev) => [...prev, url]);
          });
        }
      );
    });
  } else {
    Promise.all(promises)
      .then(async () => {
        if (mediaURLs.length === Array.from(uploadImage).length) {
          await action();
        }
      })
      .catch((err) => {
        toast.error("There is an error adding document, try again");
        setLoading(false);
      });
  }
};

export const uploadMultipleClaim = async (uploadImage, mediaURLs, setMediaURLs, setLoading, done, action) => {
  const promises = [];
  if (!done) {
    Array.from(uploadImage).forEach((image) => {
      const imageRef = ref(storage, `claims/${v4()}${image.name}`);
      const uploadTask = uploadBytesResumable(imageRef, image);
      promises.push(uploadTask);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          setLoading(true);
        },
        (error) => {
          console.log(error.message);
          setLoading(false);
        },
        async () => {
          await getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            setMediaURLs((prev) => [...prev, url]);
          });
        }
      );
    });
  } else {
    Promise.all(promises)
      .then(async () => {
        if (mediaURLs.length === Array.from(uploadImage).length) {
          await action();
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("There is an error adding claim, try again");
        setLoading(false);
      });
  }
};

export const uploadProject = async (uploadImage, mediaURLs, setMediaURLs, setLoading, done, action) => {
  const promises = [];
  if (!done) {
    Array.from(uploadImage).forEach((image) => {
      const imageRef = ref(storage, `projects/${v4()}${image?.file.name}`);
      const uploadTask = uploadBytesResumable(imageRef, image?.file);
      promises.push(uploadTask);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          setLoading(true);
        },
        (error) => {
          console.log(error.message);
          setLoading(false);
        },
        async () => {
          await getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            setMediaURLs((prev) => [...prev, url]);
          });
        }
      );
    });
  } else {
    Promise.all(promises)
      .then(async () => {
        if (mediaURLs.length === Array.from(uploadImage).length) {
          await action();
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("There is an error adding claim, try again");
        setLoading(false);
      });
  }
};


export const uploadPost = async (uploadMedia, uploadedMedia, setUploadedMedia, setLoader, done, action) => {
  const promises = [];
  
  if(!done) {
    Array.from(uploadMedia).forEach((media) => {
      const type = media?.type.split("/")[0];
      const mediaRef = ref(storage, `posts/${v4()}${media?.name}`);
      const uploadTask = uploadBytesResumable(mediaRef, media);
      promises.push(uploadTask);
      uploadTask.on("state_changed",
        (snapshot) => {
          setLoader(true);
        },
        (error) => {
          console.log(error.message);
          setLoader(false);
        },
        async() => {
          await getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            setUploadedMedia((prev) => [...prev, {
              url, type
            }]);
          });
        }
      )
    });
  } else{
      Promise.all(promises)
        .then(async () => {
          if (uploadedMedia.length === Array.from(uploadMedia).length) {
            await action();
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error("There is an error adding post, try again");
          setLoader(false);
        });
  }
}
